"use client";

import { useEffect, useState } from "react";
import { useDataContext } from "@/contexts/DataContext";
import { PageLayout } from "@/components/ui/PageLayout.tsx";
import { PoolsTable } from "@/components/PoolsTable";
import { TopPools } from "@/components/TopPools";
import { STABLECOIN_IDS } from "@/utils/utilities";
import type { PoolRiskApiResponseObject } from "@/utils/types";

export default function PoolsPage() {
  const { poolRiskData, period, loading, pairs, tokens, getPeriodData } = useDataContext();

  // Local, fixed-30d dataset for TopPools
  const [topPools30d, setTopPools30d] = useState<PoolRiskApiResponseObject[]>([]);

  useEffect(() => {
    let cancelled = false;

    async function load30d() {
      try {
        const { poolRiskData } = await getPeriodData("30d");
        if (!cancelled) setTopPools30d(poolRiskData);
      } catch (err) {
        if (!cancelled) console.error(err);
      }
    }
    void load30d();
    return () => { cancelled = true; };
  }, [getPeriodData]);

  if (loading) {
    return (
      <section className="relative">
        <div className="container max-w-7xl mx-auto px-4 py-6 space-y-6">Loading pools data...</div>
      </section>
    );
  }

  return (
    <PageLayout>
      <div className="space-y-6 anim-fadeSlideInUp-500ms">
        <div className="mb-7 anim-fadeSlideInLeft-500ms" style={{ animationDelay: "0.2s" }}>
          <h1 className="text-[28px] font-normal font-serif leading-tight mb-1">Pools</h1>
          <p className="text-[11px] tracking-[0.04em]" style={{ color: "var(--text-tertiary)" }}>Find the most profitable LPs across protocols</p>
        </div>

        <TopPools
          data={topPools30d}       // ← always 30d snapshot
          pairs={pairs}
          tokens={tokens}
          stablecoinIds={STABLECOIN_IDS}
          period={"30d"}
        />

        <div className="flex items-center justify-end">
          <button
            className="docs-btn"
            onClick={() => window.open("https://api.hoops.finance", "_blank")}
          >
            <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" /><polyline points="14 2 14 8 20 8" /></svg>
            READ THE DOCS
          </button>
        </div>

        <div className="anim-fadeSlideInUp-300ms" style={{ animationDelay: "0.4s" }}>
          <PoolsTable data={poolRiskData} pairs={pairs} tokens={tokens} />
        </div>
      </div>
    </PageLayout>
  );
}
